import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { loadAction } from "./actions";

const metadata = createSlice({
  name: "metadata",
  initialState: { title: "", customerName: "", orderRef: "", worldOrder: "" },
  reducers: {
    customerNameUpdated: (state, action: PayloadAction<string>) => ({
      ...state,
      customerName: action.payload,
    }),
    orderRefUpdated: (state, action: PayloadAction<string>) => ({
      ...state,
      orderRef: action.payload,
    }),
    titleUpdated: (state, action: PayloadAction<string>) => ({
      ...state,
      title: action.payload,
    }),
    worldOrderUpdated: (state, action: PayloadAction<string>) => ({
      ...state,
      worldOrder: action.payload,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(loadAction, (state, action) => ({
      ...state,
      ...action.payload.metadata,
    }));
  },
});

export default metadata;
